import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { methodTypeEnumProvider, PayableReceivablesListViewModel, row, statusEnumProvider, TransactionTypeEnumProvider } from "./payableReceivablesList-viewModel"

export class PayableReceivablesListView extends View<PayableReceivablesListViewModel>{
    GetViewUniqueId(): string {
        return "V-B22F1F13-61AF-4B1B-B94B-746C786D0EE2"
    }
    loadHtml(): string {
        let element = require('./payableReceivablesList.html').default;
        let style = require('./payableReceivablesList.less');
        return element;
    }
    constructor() {
       super();
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set methodEnumProvider(v: methodTypeEnumProvider) { this._typeEnumProvider = v; } public get methodEnumProvider(): methodTypeEnumProvider { return this._typeEnumProvider;} private _typeEnumProvider: methodTypeEnumProvider;
    public set transactionTypeEnumProvider(v: TransactionTypeEnumProvider) { this._transactionTypeEnumProvider = v; } public get transactionTypeEnumProvider(): TransactionTypeEnumProvider { return this._transactionTypeEnumProvider;} private _transactionTypeEnumProvider: TransactionTypeEnumProvider;
    public set rows(v: ObservableArray<row>) { this._rows = v; } public get rows(): ObservableArray<row> { return this._rows;} private _rows: ObservableArray<row>;
    public set statusEnumProvider(v: statusEnumProvider) { this._statusEnumProvider = v; } public get statusEnumProvider(): statusEnumProvider { return this._statusEnumProvider;} private _statusEnumProvider: statusEnumProvider;
    public set filterDayFrom(v: moment.Moment) { this._filterDayFrom = v; } public get filterDayFrom(): moment.Moment { return this._filterDayFrom;} private _filterDayFrom: moment.Moment;
    public set filterDayTo(v: moment.Moment) { this._filterDayTo = v; } public get filterDayTo(): moment.Moment { return this._filterDayTo;} private _filterDayTo: moment.Moment;
        
    public set totalPay(v: number) { this._totalPay = v; } public get totalPay(): number { return this._totalPay;} private _totalPay: number;
    public set totalReceive(v: number) { this._totalReceive = v; } public get totalReceive(): number { return this._totalReceive;} private _totalReceive: number;
    
    apply(){
        this.dataContext.apply();
    }
}
